import React from 'react';

const Section = ({
  children,
  background = 'white',
  className = '',
  id = '',
}) => {
  const backgrounds = {
    white: 'bg-white',
    light: 'bg-light-bg',
    dark: 'bg-dark-bg text-white',
    gradient: 'bg-gradient-primary text-white',
  };

  return (
    <section
      id={id}
      className={`py-16 md:py-24 ${backgrounds[background]} ${className}`}
    >
      <div className="container mx-auto px-4 sm:px-6 lg:px-8 max-w-7xl">
        {children}
      </div>
    </section>
  );
};

export default Section;
